<template>
  <GlobalTopbarContainer>
    <template #left>
      <FriedSkeleton v-if="isXSmallScreenAndUp" class="topbar-button create-button" />
    </template>
    <template #right>
      <FriedSkeleton v-if="isSmallScreenAndUp" class="topbar-button support-button" />
      <FriedSkeleton v-if="isSmallScreenAndUp" class="topbar-button profile-select" />
      <FriedSkeleton v-if="isSmallScreenAndDown" class="topbar-button topbar-round-button" />
      <FriedSkeleton v-if="isSmallScreenAndDown" class="topbar-button topbar-round-button" />
      <FriedSkeleton v-if="isSmallScreenAndDown" class="topbar-button" />
    </template>
  </GlobalTopbarContainer>
</template>

<script lang="ts" setup>
import useBreakpoints from '@getaccept/lib-shared/src/composables/breakpoints.composable';
import GlobalTopbarContainer from './GlobalTopbarContainer.vue';

const { isSmallScreenAndUp, isSmallScreenAndDown, isXSmallScreenAndUp } = useBreakpoints();
</script>

<style lang="scss" scoped>
.topbar-button {
  width: 2rem;
  height: 2rem;
}

.create-button {
  width: 5.5rem;
}

.topbar-round-button {
  border-radius: 1.25rem;
}

.support-button {
  width: 125px;
  border-radius: 40px;
}

.profile-select {
  width: 230px;
}
</style>
